import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../config/constants';
import { Phone, Mail, MessageCircle, MapPin, SquareCheckBig, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-white text-gray-800 relative overflow-hidden border-t border-gray-200">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-50 rounded-full blur-3xl opacity-30"></div>

      <div className="max-w-7xl mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Columna: Información del negocio */}
          <div className="md:col-span-1">
            <Link to={ROUTES.HOME} className="inline-block mb-4 group">
              <img 
                src="/logo-optimized.png" 
                alt="MisTramites.mx" 
                className="h-11 w-auto transform group-hover:scale-105 transition-transform duration-300"
              />
            </Link>
            <p className="text-gray-600 text-sm mb-4 leading-relaxed">
              Tu aliado confiable para todos tus trámites gubernamentales en México.
            </p>
            
            {/* Social media icons */}
            <div className="flex space-x-3">
              {[
                { icon: Facebook, href: '#' },
                { icon: Twitter, href: '#' },
                { icon: Instagram, href: '#' },
                { icon: Linkedin, href: '#' }
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.href}
                  className="w-10 h-10 bg-gray-100 hover:bg-blue-100 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 border border-gray-200"
                >
                  <social.icon className="w-5 h-5 text-gray-600 hover:text-blue-600 transition-colors" />
                </a>
              ))}
            </div>
          </div>

          {/* Columna: Links importantes */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <FooterLink to={ROUTES.HOME} text="Inicio" />
              <FooterLink to={ROUTES.CATEGORIES} text="Categorías" />
              <FooterLink to={ROUTES.LOGIN} text="Iniciar Sesión" />
              <FooterLink to={ROUTES.REGISTER} text="Registrarse" />
            </ul>
          </div>

          {/* Columna: Recursos */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Recursos</h3>
            <ul className="space-y-2">
              <FooterLink to="/faq" text="Preguntas Frecuentes" />
              <FooterLink to="/contacto" text="Contacto" />
              <FooterLink to="/soporte" text="Soporte" />
              <FooterLink href="/legal/terminos.html" text="Condiciones del Servicio" />
              <FooterLink href="/legal/privacidad.html" text="Aviso de Privacidad" />
              <FooterLink href="/legal/eliminar-datos.html" text="Eliminación de Datos" />
            </ul>
          </div>

          {/* Columna: Contacto */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">Contacto</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:contacto@mistramites.mx"
                  className="flex items-center text-gray-600 hover:text-blue-600 transition-colors group"
                >
                  <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center mr-3 group-hover:bg-blue-100 transition-colors">
                    <Mail className="w-4 h-4 text-blue-600" />
                  </div>
                  <span className="text-sm">contacto@mistramites.mx</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+525585353729"
                  className="flex items-center text-gray-600 hover:text-blue-600 transition-colors group"
                >
                  <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
                    <Phone className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-sm">55 8535 3729</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/525585353729"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-600 hover:text-green-600 transition-colors group"
                >
                  <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
                    <MessageCircle className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-sm">WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8"></div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-gray-600 text-sm text-center md:text-left space-y-1">
            <p>&copy; {new Date().getFullYear()} MisTramites.mx. Todos los derechos reservados.</p>
            <p>MisTramites es un producto desarrollado por ACXOR, una marca comercial de FORTIA SYSTEMS, S.A. de C.V.</p>
          </div>
          <div className="flex space-x-6">
            <a href="/legal/terminos.html" className="text-gray-600 hover:text-blue-600 text-sm transition-colors">
              Términos
            </a>
            <a href="/legal/privacidad.html" className="text-gray-600 hover:text-blue-600 text-sm transition-colors">
              Privacidad
            </a>
            <a href="/legal/eliminar-datos.html" className="text-gray-600 hover:text-blue-600 text-sm transition-colors">
              Eliminación de datos
            </a>
            <Link to="/cookies" className="text-gray-600 hover:text-blue-600 text-sm transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ to, href, text }) => {
  const className = "text-gray-600 hover:text-blue-600 transition-colors text-sm flex items-center group";
  const content = (
    <>
      <span className="w-0 h-px bg-blue-600 group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
      {text}
    </>
  );
  return (
    <li>
      {href ? (
        <a href={href} className={className}>{content}</a>
      ) : (
        <Link to={to} className={className}>{content}</Link>
      )}
    </li>
  );
};

export default Footer;